import * as C from 'actions/constants';

export const blankState = {
  data: {},
};

const CurrentUserReducer = (state = blankState, action) => {
  switch (action.type) {
    case C.LOAD_CURRENT_USER: {
      return { ...state, loading: true };
    }
    case C.LOAD_CURRENT_USER_SUCCESS: {
      const { data } = action;
      return { ...state, loading: false, data };
    }
    case C.LOAD_CURRENT_USER_ERROR: {
      return { ...state, loading: false };
    }
    default:
      return state;
  }
};

export default CurrentUserReducer;
